import { useEffect } from "react";
import { Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import { Navbar } from "../components/landing/Navbar";
import {
  BlogSection,
  ContactSection,
  Footer,
  ProblemSection,
  SolutionSection,
} from "../components/landing/Sections";
import { siteConfig } from "../data/mock";
import "../App.css";

function LandingHero() {
  return (
    <section className="problems-hero" id="problem-file">
      <div className="container problems-hero-grid clean-hero">
        <div className="problems-hero-copy">
          <div className="yc-badge">
            <div className="yc-badge-icon">Y</div>
            <span>Backed by Y Combinator</span>
          </div>
          <h1>
            <span className="headline-line">Enterprise SaaS</span>
            <span className="headline-line">
              deployed in <span className="crossed-word">months</span>{" "}
              <span className="tilted-word">weeks</span>
            </span>
          </h1>
          <p className="hero-summary">
            Lab0 builds AI agents that turn enterprise software from a
            consulting-heavy deployment into a self-serve product. Compress
            implementation timelines from 3-12 months to weeks.
          </p>
          <p className="founder-line">
            IIT Bombay <span>·</span> IIT Madras <span>·</span> Ex-Founders{" "}
            <span>·</span> Ex-Emergent
          </p>
          <div className="hero-actions" aria-label="Hero actions">
            <a className="primary-action" href={siteConfig.demoUrl} target="_blank" rel="noreferrer">
              <Calendar size={18} aria-hidden="true" />
              Book a demo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function ServiceNowUpdateBanner() {
  return (
    <section className="homepage-update" aria-label="ServiceNow update">
      <div className="container">
        <div className="homepage-update-panel">
          <span className="homepage-update-dot" aria-hidden="true" />
          <p className="homepage-update-copy">
            <strong>ServiceNow rollout demo is live.</strong>
            <span>Watch how Lab0 turns discovery, configuration, and validation into one deployment loop.</span>
          </p>
          <Link className="homepage-update-link" to="/servicenow">
            Watch update
          </Link>
        </div>
      </div>
    </section>
  );
}

export default function LandingPage() {
  useEffect(() => {
    document.title = "Lab0 | Enterprise software deployed in weeks";

    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    if (!window.location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#fafaf9] text-[#1a1a1a]">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <ServiceNowUpdateBanner />
        <LandingHero />
        <ProblemSection />
        <SolutionSection />
        <BlogSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
